import React, {
  useState,
  useEffect,
  useContext,
} from "react";

import AgregarFamiliaDb from "../firebase/AgregarFamiliaDb";
import Alertas from "./Alertas";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import {
  useNavigate,
} from "react-router-dom";

import { FaRegEdit } from "react-icons/fa";

import {
  getDocs,
  collection,
  where,
  query,
  limit,
} from "firebase/firestore";

import { UserContext } from "../context/UserContext";
import ExportarExcel from "../funciones/ExportarExcel";

import {
  Table,
  Container,
  Segment,
  Input,
  Form,
  Header,
  Button,
  Icon,
} from "semantic-ui-react";

const AgregarFamilia = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  const navigate = useNavigate();

  const [
    estadoAlerta,
    cambiarEstadoAlerta,
  ] = useState(false);

  const [
    alerta,
    cambiarAlerta,
  ] = useState({});

  const [
    familia,
    setFamilia,
  ] = useState("");

  const [
    leer,
    setLeer,
  ] = useState([]);

  const [
    buscador,
    setBuscador,
  ] = useState("");

  const [
    flag,
    setFlag,
  ] = useState(false);

  const [
    verificandoId,
    setVerificandoId,
  ] = useState(null);

  // ==========================================================
  // AGREGAR FAMILIA
  // ==========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    const familiaNormalizada =
      String(familia || "")
        .toLocaleUpperCase()
        .trim();

    // ========================================================
    // VALIDAR VACÍO
    // ========================================================

    if (!familiaNormalizada) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No ha ingresado una familia.",
      });

      return;
    }

    // ========================================================
    // VALIDAR DUPLICADO
    // ========================================================

    const existe = leer.some(
      (item) =>
        String(
          item.familia || ""
        )
          .toLocaleUpperCase()
          .trim() ===
        familiaNormalizada
    );

    if (existe) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Ya existe esta familia.",
      });

      return;
    }

    try {
      const fechaActual =
        new Date();

      await AgregarFamiliaDb({
        familia:
          familiaNormalizada,

        activo: true,

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd:
          fechaActual,

        fechaMod:
          fechaActual,

        emp_id:
          users.emp_id,
      });

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Familia ingresada correctamente.",
      });

      setFamilia("");

      setFlag(
        (prev) => !prev
      );
    } catch (error) {
      console.error(
        "Error al agregar familia:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible ingresar la familia.",
      });
    }
  };

  // ==========================================================
  // OBTENER FAMILIAS
  // ==========================================================

  const getData = async () => {
    if (!users?.emp_id) {
      return;
    }

    try {
      const familiasRef =
        collection(
          db,
          "familias"
        );

      const qFamilias =
        query(
          familiasRef,

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "activo",
            "==",
            true
          )
        );

      const data =
        await getDocs(
          qFamilias
        );

      const familias =
        data.docs.map(
          (doc) => ({
            ...doc.data(),
            id: doc.id,
          })
        );

      familias.sort(
        (a, b) =>
          String(
            a.familia || ""
          ).localeCompare(
            String(
              b.familia || ""
            )
          )
      );

      setLeer(
        familias
      );
    } catch (error) {
      console.error(
        "Error al obtener familias:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar las familias.",
      });
    }
  };

  // ==========================================================
  // VERIFICAR SI LA FAMILIA YA ESTÁ SIENDO UTILIZADA
  // ==========================================================

  const verificarFamiliaEnUso =
    async (
      nombreFamilia
    ) => {
      if (!users?.emp_id) {
        throw new Error(
          "No se encontró la empresa del usuario"
        );
      }

      const nombreNormalizado =
        String(
          nombreFamilia ||
            ""
        )
          .toLocaleUpperCase()
          .trim();

      if (!nombreNormalizado) {
        return false;
      }

      // ======================================================
      // 1. HOMECARE
      // Primera propagación: equipos
      // ======================================================

      const qEquipos =
        query(
          collection(
            db,
            "equipos"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "familia",
            "==",
            nombreNormalizado
          ),

          limit(1)
        );

      const snapEquipos =
        await getDocs(
          qEquipos
        );

      if (
        !snapEquipos.empty
      ) {
        return true;
      }

      // ======================================================
      // 2. SERVICIO TÉCNICO
      // Primera propagación: ingresostcab
      // ======================================================

      const qIngresos =
        query(
          collection(
            db,
            "ingresostcab"
          ),

          where(
            "emp_id",
            "==",
            users.emp_id
          ),

          where(
            "familia",
            "==",
            nombreNormalizado
          ),

          limit(1)
        );

      const snapIngresos =
        await getDocs(
          qIngresos
        );

      if (
        !snapIngresos.empty
      ) {
        return true;
      }

      return false;
    };

  // ==========================================================
  // EDITAR FAMILIA
  // ==========================================================

  const editarFamilia =
    async (item) => {
      if (
        !item?.id ||
        !item?.familia
      ) {
        return;
      }

      cambiarEstadoAlerta(
        false
      );

      cambiarAlerta({});

      setVerificandoId(
        item.id
      );

      try {
        const enUso =
          await verificarFamiliaEnUso(
            item.familia
          );

        if (enUso) {
          cambiarEstadoAlerta(
            true
          );

          cambiarAlerta({
            tipo: "error",

            mensaje:
              "Esta familia ya está siendo utilizada en el sistema y no puede modificarse.",
          });

          return;
        }

        navigate(
          `/actualizafamilia/${item.id}`
        );
      } catch (error) {
        console.error(
          "Error verificando uso de familia:",
          error
        );

        cambiarEstadoAlerta(
          true
        );

        cambiarAlerta({
          tipo: "error",

          mensaje:
            "No fue posible verificar si la familia puede modificarse.",
        });
      } finally {
        setVerificandoId(
          null
        );
      }
    };

  // ==========================================================
  // FILTRO
  // ==========================================================

  const filtroFamilia =
    leer.filter(
      (item) =>
        Object.keys(
          item
        ).some(
          (key) =>
            String(
              item[key] ?? ""
            )
              .toLowerCase()
              .includes(
                buscador.toLowerCase()
              )
        )
    );

  // ==========================================================
  // EXPORTAR EXCEL
  // ==========================================================

  const ExportarXls =
    () => {
      const columnsToShow =
        [
          "id",
          "familia",
        ];

      const excelBlob =
        ExportarExcel(
          leer,
          columnsToShow
        );

      const excelURL =
        URL.createObjectURL(
          excelBlob
        );

      const downloadLink =
        document.createElement(
          "a"
        );

      downloadLink.href =
        excelURL;

      downloadLink.download =
        "familia.xlsx";

      document.body.appendChild(
        downloadLink
      );

      downloadLink.click();

      document.body.removeChild(
        downloadLink
      );

      URL.revokeObjectURL(
        excelURL
      );
    };

  // ==========================================================
  // USE EFFECT
  // ==========================================================

  useEffect(() => {
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    flag,
    users?.emp_id,
  ]);

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth: 1400,
        padding:
          "24px 28px",
        background:
          "#f8fafc",
        minHeight:
          "100vh",
      }}
    >
      {/* ==================================================== */}
      {/* ENCABEZADO */}
      {/* ==================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems:
            "center",
          marginBottom: 20,
          gap: 20,
          flexWrap:
            "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems:
              "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              minWidth: 48,
              borderRadius: 12,
              background:
                "#e5f7f7",
              display: "flex",
              alignItems:
                "center",
              justifyContent:
                "center",
            }}
          >
            <Icon
              name="folder open outline"
              style={{
                margin: 0,
                color:
                  "#0d9da5",
                fontSize: 21,
              }}
            />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin: 0,
                color:
                  "#172b4d",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Familias de Equipos
            </Header>

            <div
              style={{
                color:
                  "#8793a5",
                fontSize: 13,
                marginTop: 4,
              }}
            >
              Administra las familias de equipamiento médico utilizadas en el sistema
            </div>
          </div>
        </div>

        <Button
          type="button"
          onClick={
            ExportarXls
          }
          style={{
            background:
              "#ffffff",
            color:
              "#526273",
            border:
              "1px solid #d7dee7",
            borderRadius: 6,
            boxShadow:
              "none",
          }}
        >
          <Icon
            name="file excel outline"
            style={{
              color:
                "#21ba45",
            }}
          />

          Exportar Excel
        </Button>
      </div>

      {/* ==================================================== */}
      {/* AGREGAR FAMILIA */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background:
            "#ffffff",
          overflow:
            "hidden",
          marginBottom: 14,
        }}
      >
        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            alignItems:
              "center",
            gap: 9,
            fontWeight: 600,
            color:
              "#253858",
          }}
        >
          <Icon
            name="plus circle"
            style={{
              color:
                "#0d9da5",
            }}
          />

          Agregar nueva familia
        </div>

        <div
          style={{
            padding: 18,
          }}
        >
          <Form
            onSubmit={
              handleSubmit
            }
          >
            <div
              style={{
                display:
                  "flex",
                gap: 10,
                alignItems:
                  "center",
                flexWrap:
                  "wrap",
              }}
            >
              <div
                style={{
                  flex: 1,
                  minWidth:
                    280,
                }}
              >
                <Input
                  fluid
                  size="large"
                  icon="tag"
                  iconPosition="left"
                  type="text"
                  placeholder="Ingrese Familia Equipamiento Médico"
                  name="familia"
                  value={
                    familia
                  }
                  onChange={(
                    e
                  ) =>
                    setFamilia(
                      e
                        .target
                        .value
                    )
                  }
                />
              </div>

              <Button
                type="submit"
                style={{
                  minWidth:
                    120,
                  height: 42,
                  background:
                    "#0d9da5",
                  color:
                    "#ffffff",
                  borderRadius:
                    6,
                  boxShadow:
                    "none",
                }}
              >
                <Icon name="plus" />
                Agregar
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ==================================================== */}
      {/* LISTADO */}
      {/* ==================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background:
            "#ffffff",
          overflow:
            "hidden",
        }}
      >
        {/* CABECERA */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems:
              "center",
            gap: 15,
            flexWrap:
              "wrap",
          }}
        >
          <div
            style={{
              display:
                "flex",
              alignItems:
                "center",
              gap: 8,
              fontWeight:
                600,
              color:
                "#253858",
            }}
          >
            <Icon
              name="list"
              style={{
                color:
                  "#0d9da5",
              }}
            />

            Familias registradas

            <span
              style={{
                marginLeft:
                  8,
                fontSize: 11,
                color:
                  "#98a1af",
                fontWeight:
                  400,
              }}
            >
              {
                filtroFamilia.length
              }{" "}
              registros
            </span>
          </div>

          <div
            style={{
              width: 340,
              maxWidth:
                "100%",
            }}
          >
            <Input
              fluid
              icon="search"
              iconPosition="left"
              placeholder="Buscar familia"
              value={
                buscador
              }
              onChange={(
                e
              ) =>
                setBuscador(
                  e
                    .target
                    .value
                )
              }
            />
          </div>
        </div>

        {/* TABLA */}

        <div
          style={{
            maxHeight:
              520,
            overflowY:
              "auto",
            overflowX:
              "auto",
          }}
        >
          <Table
            celled
            compact
            selectable
            style={{
              margin: 0,
              border: 0,
              borderRadius:
                0,
              fontSize: 12,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Familia
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Agregado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  style={
                    stickyTh
                  }
                >
                  Modificado por
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={
                    stickyTh
                  }
                >
                  Acción
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {filtroFamilia.map(
                (
                  item,
                  index
                ) => (
                  <Table.Row
                    key={
                      item.id ||
                      index
                    }
                  >
                    <Table.Cell
                      textAlign="center"
                    >
                      {index +
                        1}
                    </Table.Cell>

                    <Table.Cell
                      style={{
                        fontWeight:
                          500,
                        color:
                          "#344563",
                      }}
                    >
                      {
                        item.familia
                      }
                    </Table.Cell>

                    <Table.Cell>
                      {item.useradd ||
                        item.userAdd ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell>
                      {item.usermod ||
                        item.userMod ||
                        "-"}
                    </Table.Cell>

                    <Table.Cell
                      textAlign="center"
                    >
                      <Button
                        icon
                        size="mini"
                        type="button"
                        title="Editar familia"
                        loading={
                          verificandoId ===
                          item.id
                        }
                        disabled={
                          verificandoId !==
                            null &&
                          verificandoId !==
                            item.id
                        }
                        onClick={() =>
                          editarFamilia(
                            item
                          )
                        }
                        style={{
                          width:
                            34,
                          height:
                            30,
                          padding:
                            0,
                          margin:
                            0,
                          borderRadius:
                            5,
                          border:
                            "1px solid #168bc1",
                          background:
                            "#f4fbfe",
                          boxShadow:
                            "none",
                        }}
                      >
                        {verificandoId !==
                          item.id && (
                          <FaRegEdit
                            style={{
                              fontSize:
                                15,
                              color:
                                "#168bc1",
                            }}
                          />
                        )}
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                )
              )}

              {filtroFamilia.length ===
                0 && (
                <Table.Row>
                  <Table.Cell
                    colSpan={5}
                    textAlign="center"
                    style={{
                      padding:
                        28,
                      color:
                        "#8995a3",
                    }}
                  >
                    <Icon
                      name="search"
                      style={{
                        marginRight:
                          6,
                      }}
                    />

                    No se encontraron familias
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>

        {/* FOOTER */}

        {filtroFamilia.length >
          0 && (
          <div
            style={{
              padding:
                "12px 18px",
              borderTop:
                "1px solid #edf0f4",
              color:
                "#697586",
              fontSize:
                12,
            }}
          >
            Mostrando{" "}
            <strong>
              {
                filtroFamilia.length
              }
            </strong>{" "}
            familias
          </div>
        )}
      </Segment>

      {/* ==================================================== */}
      {/* ALERTAS */}
      {/* ==================================================== */}

      <Alertas
        tipo={
          alerta.tipo
        }
        mensaje={
          alerta.mensaje
        }
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

// ============================================================
// HEADER STICKY
// ============================================================

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background:
    "#f8fafc",
  color:
    "#344563",
  fontWeight:
    600,
};

export default AgregarFamilia;